import { ArrowUp, Mail, Sparkle } from 'lucide-react';
import { contact } from '@/lib/portfolio';
import { Reveal } from './Reveal';
import { SocialLinks } from './SocialLinks';

export function Footer() {
  return (
    <footer id="contact" className="relative scroll-mt-28 overflow-hidden">
      {/* Glow floor */}
      <div className="absolute -bottom-48 left-1/2 size-[42rem] -translate-x-1/2 rounded-full bg-pulsar/15 blur-[140px]" aria-hidden="true" />

      <div className="container relative pb-16 pt-28 text-center md:pt-36">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.4em] text-muted-foreground">
            Transmission ends
          </p>
          <h2 className="mx-auto mt-6 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight md:text-7xl">
            Got a wild{' '}
            <span className="bg-gradient-to-r from-nova via-flare to-pulsar bg-clip-text text-transparent">
              idea?
            </span>
          </h2>
          <p className="mt-4 font-serif text-3xl italic text-muted-foreground md:text-4xl">
            let&rsquo;s build it.
          </p>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
            Hackathons, collabs, speaking gigs, or a friendly argument about which chain is
            actually best &mdash; the verse is always expanding, and there&rsquo;s room in the
            next chapter.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col items-center gap-7">
            <a
              href={`mailto:${contact.email}`}
              className="group flex items-center gap-3 font-display text-lg font-semibold tracking-tight underline decoration-nova/60 decoration-2 underline-offset-[10px] transition-colors hover:text-nova hover:decoration-nova md:text-3xl"
            >
              <Mail className="size-5 shrink-0 text-nova transition-transform group-hover:-translate-y-0.5 md:size-7" />
              {contact.email}
            </a>

            <SocialLinks withLabels />

            <a
              href="#top"
              className="group mt-2 flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-semibold transition-colors hover:border-white/40 hover:bg-white/5"
            >
              Back to orbit
              <ArrowUp className="size-4 transition-transform group-hover:-translate-y-0.5" />
            </a>
          </div>
        </Reveal>
      </div>

      <div className="relative border-t border-white/10">
        <div className="container flex flex-col items-center justify-between gap-4 py-8 text-sm text-muted-foreground md:flex-row">
          <p className="flex items-center gap-2">
            <Sparkle className="size-3.5 text-flare" aria-hidden="true" />
            &copy; 2026 Immaculate Munde &mdash; Nairobi, Kenya
          </p>
          <p className="font-serif italic">Proof of taste, on-chain and off.</p>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-foreground"
          >
            Vibed with Shakespeare
          </a>
        </div>
      </div>
    </footer>
  );
}
